import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./MobileTabBar.css";

const menu = [
  { to: "/dashboard", icon: "home" },
  { to: "/tournament-dashboard", icon: "emoji_events" },
  { to: "/UserManagement", icon: "manage_accounts" },
  { to: "/TunamentPlayers", icon: "directions_run" },
  { to: "/TournamentPlayerReview", icon: "playlist_add_check" },
  { to: "/TournamentSquads", icon: "groups" },
  { to: "/TournamentFixture", icon: "event" },
  { to: "/TournamentSchedule", icon: "event_note" },
  { to: "/team-logos", icon: "image" },
  { to: "/player-photo-submissions", icon: "account_box" },
  { to: "/LiveScores", icon: "sports_score" },
  { to: "/logs", icon: "history" },
  { to: "/cache", icon: "memory" },
  { to: "/visitor-bandwidth", icon: "analytics" },
  { to: "/edit-profile", icon: "edit" },
  { to: "/settings", icon: "settings" },
];

export default function MobileTabBar() {
  const location = useLocation();

  return (
    <div className="mobile-slider-menu">
      <div className="slider-track">
        {menu.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`slider-tab${
              location.pathname === item.to ? " active" : ""
            }`}
          >
            <span className="material-icons slider-icon">{item.icon}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
